"use strict";
(function (global) {

  /**
  * Редактор для ячейки с реквизитом множественного выбора.  
  * @class WebAccess.components.dataViews.gridPlugins._editors.ReferenceEditor
  * @extends WebAccess.components.dataViews.gridPlugins._editors.BaseObjectSelectEditor
  * @since 5.2.0.1300
  */
  global.ReferenceEditor = global.BaseObjectSelectEditor.extend({
    _renderer: null,
    _wrapper: null,
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Создает рендерер.
     * @private
     */
    _createRenderer: function () {
      return new WebAccess.components.forms.requisites.ReferenceSelect();
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Создает объект-обертку над контролом реквизита, с необходимыми методами типа getValue
     * @private
     */
    _createWrapper: function (parentCurrent) {
      var me = this;
      return new WA.CMP.wrappers.form.requisites.Reference(me._column.id, me.id, parentCurrent.form);
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Проброшенный метод из клиентской ОМ
    * @method WebAccess.components.dataViews.gridPlugins._editors.ReferenceEditor#setCustomAction
    * @since 5.2.0.1300     
    */
    setReferences: function (references) {
      this._getWrapper().setReferences(references);
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Проброшенный метод из клиентской ОМ
    * @method WebAccess.components.dataViews.gridPlugins._editors.ReferenceEditor#setCustomAction
    * @since 5.2.0.1300     
    */
    setFilter: function (filter, opt_refCode) {
      this._getWrapper().setFilter(filter, opt_refCode);
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Проброшенный метод из клиентской ОМ
    * @method WebAccess.components.dataViews.gridPlugins._editors.ReferenceEditor#setCustomAction
    * @since 5.2.0.1300     
    */
    setValues: function (filter, opt_refCode) {
      this._getWrapper().setValues(filter, opt_refCode);
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Проброшенный метод из клиентской ОМ
    * @method WebAccess.components.dataViews.gridPlugins._editors.ReferenceEditor#setCustomAction
    * @since 5.2.0.1300     
    */
    setMainReference: function (referenceName) {
      this._getWrapper().setMainReference(referenceName);
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Проброшенный метод из клиентской ОМ
    * @method WebAccess.components.dataViews.gridPlugins._editors.ReferenceEditor#setCustomAction
    * @since 5.2.0.1300     
    */
    addLastObjectsPseudoReference: function (lastReferences) {
      this._getWrapper().addLastObjectsPseudoReference(lastReferences);
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Проброшенный метод из клиентской ОМ
    * @method WebAccess.components.dataViews.gridPlugins._editors.ReferenceEditor#setCustomAction
    * @since 5.2.0.1300     
    */
    removeLastObjectsPseudoReference: function (lastReferences) {
      this._getWrapper().removeLastObjectsPseudoReference(lastReferences);
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Привязка вызова справочника в модальном окне по клику на иконке в поле ввода.
    * @method WebAccess.components.dataViews.gridPlugins._editors.ReferenceEditor#bindReferenceGridDialog
    * @since 5.4.0.1012     
    */
    bindReferenceGridDialog: function () {
      this._getWrapper().bindReferenceGridDialog();
    }
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  });

})(window.WA.components.dataViews.gridPlugins._editors)